import draw from "./draw";
class TouchAnimation {
  constructor(x, y, r, ctx, rows) {
    this.anim = { x: x, y: y, r: r + 24 / rows }; // anim falling points
    this.ctx = ctx;
    this.draw = draw.bind(this);
  }
  opacity = 1;
}

export default TouchAnimation;
